module.exports = __webpack_public_path__ + "static/media/loader.3c305299.svg";